import Activity from "../../activity/model/Activity";
import DragWordToImgActivity from "../../ddTxtImg/model/DragWordToImgActivity";
import SortStoryDropItemContainer from "./SortStoryDropItemContainer";



class SortStoryActivity extends DragWordToImgActivity{

    constructor(){
        super()
        this.activityType=this.SORT_STORY
        this.dropItemContainer = new SortStoryDropItemContainer()

    }
}

export default SortStoryActivity